export default __webpack_public_path__ + "static/media/type-file.74e08a86.jpg";